import React, { useState } from 'react';
import './AccountInfoCard.css';
import { useAuth } from '../../context/AuthContext';
import ModalEditField from './updateinfo/ModalEditField';
import PhoneNumberModal from './updateinfo/PhoneNumberModal';

const AccountInfoCard = () => {
  const { user } = useAuth();

  const [editingField, setEditingField] = useState(null);
  const [editingValue, setEditingValue] = useState("");
  const [editingAction, setEditingAction] = useState("Change");

  const isProvided = (value) => {
    return typeof value === 'string' && value.trim() !== '' && value.trim().toLowerCase() !== 'not provided';
  };

  const handleEditClick = (label, value, action) => {
    setEditingField(label);
    setEditingValue(value || "");
    setEditingAction(action);
  };

  const handleSave = (newValue) => {
    setEditingField(null);
  };

  const renderRow = (label, value, actionLabel) => (
    <div className="account-info-card__row" key={label}>
      <div className="account-info-card__label">{label}</div>
      <div className={`account-info-card__value ${!isProvided(value) ? 'not-provided' : ''}`}>
        {isProvided(value) ? value : 'Not provided'}
      </div>
      <button
        className="account-info-card__action"
        onClick={() => handleEditClick(label, value, actionLabel)}
      >
        {actionLabel}
      </button>
    </div>
  );

  return (
    <div className="account-info-card">
      {renderRow("Account name", user?.displayName, "Change")}
      <div className="account-info-card__divider" />

      {renderRow("Primary email", user?.email, "Change")}
      <div className="account-info-card__divider" />

      {renderRow("Mobile phone", user?.phone, isProvided(user?.phone) ? 'Change' : 'Add')}
      <div className="account-info-card__divider" />

      {renderRow("Address", user?.address, isProvided(user?.address) ? 'Change' : 'Add')}
      <div className="account-info-card__divider" />

      {renderRow("Secondary email", user?.secondaryEmail, isProvided(user?.secondaryEmail) ? 'Change' : 'Add')}

      {editingField === "Mobile phone" ? (
        <PhoneNumberModal
          initialValue={editingValue}
          action={editingAction}
          onClose={() => setEditingField(null)}
          onSave={handleSave}
        />
      ) : editingField ? (
        <ModalEditField
          field={editingField}
          value={editingValue}
          action={editingAction}
          onClose={() => setEditingField(null)}
          onSave={handleSave}
        />
      ) : null}
    </div>
  );
};

export default AccountInfoCard;
